import axios from './axios'
import { File } from '@../../../EshJSLib/models/patient';

export async function getFiles() {
    const response = await axios.get(`/api/getFiles`) ;
    return response.data.data as File[];
}

